import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { servicesSubbrokerSsoLoginURL } from '../utils/Urls'
import LoaderScreen from '../components/Loader'
import './LocalSSOLogin.css'

// Lands here when CRM's Sub Broker Details "login" link is opened
// (subbroker_referral.auto_login = "/redirect?token=<JWT>"). Exchanges the
// token for a real session, then hands off to the normal authenticated app.
export default function SsoRedirect() {
  const [error, setError] = useState('')

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token')
    if (!token) {
      setError('This sign-in link is missing its token.')
      return undefined
    }
    let cancelled = false
    axios.post(servicesSubbrokerSsoLoginURL, { token }, { withCredentials: true })
      .then((response) => {
        if (cancelled) return
        const code = response?.data?.user?.subbroker_code
        if (response?.data?.status !== 'success' || !code) throw new Error('Unexpected sso-login response')
        localStorage.setItem('subbroker_code', code)
        window.location.assign('/')
      })
      .catch((ssoError) => {
        if (cancelled) return
        const status = ssoError?.response?.status
        setError(status === 401 ? 'This sign-in link is invalid, expired beyond recovery, or the subbroker is inactive.' : 'Unable to sign in right now. Please try again.')
      })
    return () => { cancelled = true }
  }, [])

  if (!error) return <LoaderScreen />

  return (
    <div className="login-panel">
      <div className="login-card">
        <span className="login-status"><i /> SECURE SIGN IN</span>
        <h2 style={{ fontSize: '2.2rem' }}>Sign-in link problem</h2>
        <div className="login-error" role="alert">{error}</div>
        <a className="login-change-mobile" href="/login">Go to sign in</a>
      </div>
    </div>
  )
}
